<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <ad-form />
      </div>
    </div>
  </section>
</template>

<script>
import adForm from './Temp/BrandAdFormTemp.vue'

export default {
  name: 'Tables',
  components: {
    'ad-form': adForm
  },
  methods: {
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// CrBrandAd.vue?a920a432